import React from "react";
import Style from "./index.module.scss";
import Form from "rc-field-form";
import style from "../components/LoginComponent/index.module.scss";
import FieldWithError from "../../../components/FieldWithError";
import { Button, Input, message } from "antd";
import useRequestFn from "../../../utils/useRequestFn";
import { FormFields } from "../components/LoginComponent/components/AccountMode";
import { loginRedict } from "../../../service/auth";
import { errorMessage } from "../../../service/service";

const Index = () => {
    const [onFinish, { loading }] = useRequestFn(async (data: FormFields) => {
        try {
            await loginRedict(data.loginName, data.pwd);
            window.location.href = "/";
        } catch (e) {
            message.error(errorMessage(e));
        }
    });
    return (
        <div className={Style.root}>
            <div className={Style.grid} />
            <div className={Style.orbit}>
                <span />
                <span />
                <span />
            </div>

            <div className={Style.shell}>
                <section className={Style.hero}>
                    <div className={Style.badge}>Cloud Course Teacher</div>
                    <h1>白果云</h1>

                    <div className={Style.signal}>
                        <i />
                        <i />
                        <i />
                        <span>SECURE ACCESS</span>
                    </div>
                </section>

                <section className={Style.panel}>
                    <div className={Style.panelHeader}>
                        <span>Teacher Portal</span>
                        <h2>欢迎回来</h2>
                    </div>

                    <Form
                        onFinish={onFinish}
                        className={`${style.form} ${Style.form}`}>
                        <div className={style.item}>
                            <div className={`${style.label} ${Style.label}`}>
                                账号 <i className={style.required}>*</i>
                            </div>

                            <FieldWithError
                                name="loginName"
                                initialValue=""
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入账号"
                                    }
                                ]}>
                                <Input placeholder="请输入账号" />
                            </FieldWithError>
                        </div>

                        <div className={style.item}>
                            <div className={`${style.label} ${Style.label}`}>
                                密码 <i className={style.required}>*</i>
                            </div>

                            <FieldWithError
                                name="pwd"
                                initialValue=""
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入密码"
                                    }
                                ]}>
                                <Input.Password placeholder="请输入密码" />
                            </FieldWithError>
                        </div>

                        <Button
                            type="primary"
                            htmlType="submit"
                            className={`${style.submit} ${Style.submit}`}
                            loading={loading}>
                            登录
                        </Button>
                    </Form>
                </section>
            </div>
        </div>
    );
};

export default Index;
